import { Auth } from "shared/@auth";

import InfoCard from "DreamStream/Shared/InfoCard";
import React, { useEffect, useState } from "react";
import styles from "./HomePage.module.css";
import Card from "shared/Card";
import SyncErrorsModal from "DreamStream/Shared/SyncErrorsModal";
import QuickStartCard from "./QuickStartCard";

import Loader from "shared/Loader";
import { useHome } from "./useHome";
import formatDate from "shared/@utils/formatDate";
import SyncModal from "./SyncModal";
import Button from "shared/Button";

// Icons
import EventIcon from "../assets/Events.svg";
import GroupsIcon from "../assets/Groups.svg";
// import UsersIcon from "../assets/User.svg";
import PluginsIcon from "../assets/puzzle-piece-simple-solid.svg";
import Header from "DreamStream/Shared/Header";

export function HomePage() {
  const [syncData, setSyncData] = useState(null);
  const [syncModalOpened, setSyncModalOpened] = useState(false);
  const [addSyncModalOpened, setAddSyncModalOpened] = useState(false);
  const [syncDataErrorsModalOpen, setSyncDataErrorsModalOpen] = useState(false);
  const [prevData, setPrevData] = useState(null);

  const { hasPermission } = Auth.useContainer();
  const canSync = hasPermission("dreamstream.sync") ? true : false;

  const { data, loading, sync, refetch, syncDiamonds, cancelSyncPut } =
    useHome();

  const nextSyncDate = () => {
    let nextSync = new Date();
    nextSync.setHours(0, 0, 0, 0);
    nextSync.setDate(nextSync.getDate() + 1);

    return nextSync;
  };

  useEffect(() => {
    if (data) {
      setPrevData(syncData);
      setSyncData(data);
    } else if (!data && prevData) {
      setSyncData({
        syncCompleted: prevData.syncTotal,
        syncTotal: prevData.syncTotal,
        startedOn: prevData.startedOn,
        name: prevData.name,
      });
    } else setSyncData(null);
  }, [data]);

  const handleSubmit = async (iboNumberArray) => {
    if (iboNumberArray.length > 0) {
      let resData = await sync(iboNumberArray);
      setSyncData(resData);
    }
  };

  const handleCancel = async () => {
    var syncId = "";
    if (syncData) syncId = syncData._id;
    cancelSyncPut.mutate(
      { syncId: syncId },
      {
        onSuccess: () => {
          refetch();
          setSyncData(null);
        },
      }
    );
  };

  return (
    <div>
      {syncData && syncData.errors && (
        <SyncErrorsModal
          title={"VIEW SYNC ERRORS"}
          isOpen={syncDataErrorsModalOpen}
          onClose={() => setSyncDataErrorsModalOpen(false)}
          errors={syncData.errors}
          date={syncData.startedOn}
        />
      )}

      {addSyncModalOpened && (
        <SyncModal
          diamonds={syncDiamonds}
          onSubmit={handleSubmit}
          onClose={() => {
            setAddSyncModalOpened(false);
          }}
        />
      )}

      <Header title="HOME" />
      {loading ? (
        <Loader />
      ) : (
        <div className={styles.headerContainer}>
          {syncData && (
            <SyncErrorsModal
              title={"VIEW SYNC ERRORS"}
              isOpen={syncModalOpened}
              onClose={() => setSyncModalOpened(false)}
              errors={syncData.errors}
              date={syncData.startedOn}
            />
          )}
          {syncData && (
            <InfoCard
              header={"TIME OF LAST GLOBAL SYNC"}
              body={
                syncData.syncTotal !== 0 &&
                syncData.syncTotal === syncData.syncCompleted
                  ? `${formatDate(syncData.startedOn, "MM/DD/YYYY hh:mm A PT")}`
                  : "Sync In Progress"
              }
              footer={`Next Sync: ${formatDate(
                nextSyncDate(),
                "MM/DD/YYYY"
              )} 12:01 AM`}
              btnName={
                canSync
                  ? (syncData && syncData.errors && syncData.errors.length >= 1
                      ? "ERRORS FOUND"
                      : syncData.syncTotal !== 0) &&
                    (syncData.syncTotal === syncData.syncCompleted
                      ? "SYNC"
                      : "REFRESH")
                  : null
              }
              onClick={async () => {
                if (syncData) {
                  if (syncData.errors && syncData.errors.length >= 1) {
                    setSyncModalOpened(true);
                    await refetch();
                  } else if (
                    syncData.syncTotal !== 0 &&
                    syncData.syncTotal === syncData.syncCompleted
                  ) {
                    setAddSyncModalOpened(true);
                  } else {
                    await refetch();
                  }
                }
              }}
            />
          )}

          {!syncData && (
            <InfoCard
              header={"NO SYNC IN PROGRESS"}
              btnName={canSync ? "SYNC" : null}
              onClick={async () => {
                setAddSyncModalOpened(true);
              }}
            />
          )}

          {syncData && (
            <Card className={styles.container}>
              <>
                <div className={styles.header}>
                  Sync History
                  {syncData &&
                    canSync &&
                    syncData.syncTotal !== syncData.syncCompleted && (
                      <div className={styles.headerButtonContainer}>
                        <Button
                          purpose={"delete"}
                          size={"small"}
                          children={"ERRORS"}
                          visible={
                            syncData &&
                            syncData.errors &&
                            syncData.errors.length > 0
                          }
                          onClick={() => {
                            setSyncDataErrorsModalOpen(true);
                          }}
                        />

                        <Button
                          size={"small"}
                          children={"MARK COMPLETE"}
                          onClick={handleCancel}
                        />
                      </div>
                    )}
                </div>
                <div className={styles.divider}></div>
                <div className={styles.footer}>
                  <div className={styles.infoItem}>
                    {syncData && ( // remove later on when sync with errors or something returns an object
                      <div className={styles.grid}>
                        <div className={styles.leftColumnItem}>
                          Sync Started:
                        </div>
                        <div className={styles.rightColumnItem}>
                          {formatDate(
                            syncData.startedOn,
                            "MM/DD/YYYY hh:mm:ss A PT"
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={styles.infoItem}>
                    <div className={styles.grid}>
                      <div className={styles.leftColumnItem}>Sync Status:</div>
                      <div className={styles.rightColumnItem}>
                        {syncData &&
                          (syncData.syncTotal !== 0 &&
                          syncData.syncTotal === syncData.syncCompleted
                            ? `Completed (${syncData.syncCompleted} of ${syncData.syncTotal})`
                            : syncData.syncCompleted === 0 &&
                              syncData.syncTotal === 0
                            ? "Initializing Sync..."
                            : `In Progress  (${
                                syncData.syncCompleted !== 0
                                  ? (
                                      (syncData.syncCompleted /
                                        syncData.syncTotal) *
                                      100
                                    ).toFixed(2)
                                  : 0
                              }% -  ${syncData.syncCompleted} of ${
                                syncData.syncTotal
                              })`)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.footer}>
                  <div className={styles.infoItem}>
                    {syncData && syncData.endedOn && (
                      <div className={styles.grid}>
                        <div className={styles.leftColumnItem}>Sync Ended:</div>
                        <div className={styles.rightColumnItem}>
                          {formatDate(
                            syncData.endedOn,
                            "MM/DD/YYYY hh:mm:ss A PT"
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={styles.syncName}>
                    {syncData && (
                      <div className={styles.grid}>
                        <div className={styles.rightColumnItem}>
                          {syncData.name}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {syncData &&
                  (syncData.syncTotal !== 0 ? (
                    <div className={styles.barContainer}>
                      <div
                        className={styles.bar}
                        style={{
                          width: `${
                            (syncData.syncCompleted / syncData.syncTotal) * 100
                          }%`,
                        }}
                      ></div>
                    </div>
                  ) : syncData && syncData.syncTotal === 0 ? (
                    <div className={styles.loaderContainer}>
                      <Loader />
                    </div>
                  ) : null)}
              </>
            </Card>
          )}
        </div>
      )}

      <div className={styles.quickStart}>Quick Start</div>
      {/* <div>
        <div className={styles.groupContainer}>
          <QuickStartCard
            title={"GROUPS"}
            src={GroupsIcon}
            description={
              "View groups, manage admin, edit group details and manage group members."
            }
            to={`/groups`}
            iconStyles={styles.groups}
          />
          <QuickStartCard
            title={"USERS"}
            src={UsersIcon}
            description={
              "View Users, sync errors, and manage individual user details."
            }
            to={`/users`}
          />
          <QuickStartCard
            title={"PLUGINS"}
            src={PluginsIcon}
            description={
              "View all active plugins, create new plugins or delete plugins."
            }
            to={`/plugins`}
            iconStyles={styles.plugin}
          />
        </div>
        <div className={styles.groupTwoContainer}>
          <QuickStartCard
            title={"EVENTS"}
            src={EventIcon}
            description={
              "Manage registered event groups and view audience capture snapshots."
            }
            to={`/events`}
          />
        </div>
      </div> */}
      <div className={styles.cardContainer}>
        {/* <div className={styles.group}> */}
        <div className={styles.groupsCard}>
          <QuickStartCard
            title={"GROUPS"}
            src={GroupsIcon}
            description={
              "View groups, manage admin, edit group details and manage group members."
            }
            to={`/groups`}
            iconStyles={styles.groups}
          />
        </div>
        {/* <QuickStartCard
            title={"USERS"}
            src={UsersIcon}
            description={
              "View Users, sync errors, and manage individual user details."
            }
            to={`/users`}
          /> */}
        {/* </div> */}
        {/* <div className={styles.groupTwo}> */}

        {hasPermission("developer.*") && (
          <div className={styles.eventsCard}>
            <QuickStartCard
              title={"EVENTS"}
              src={EventIcon}
              description={
                "Manage registered event groups and view audience capture snapshots."
              }
              to={`/events`}
            />
          </div>
        )}

        <div className={styles.pluginsCard}>
          <QuickStartCard
            title={"PLUGINS"}
            src={PluginsIcon}
            description={
              "View all active plugins, create new plugins or delete plugins."
            }
            to={`/plugins`}
            iconStyles={styles.plugin}
          />
        </div>
      </div>
    </div>
  );
}
